// extracted by mini-css-extract-plugin
export var banner = "_gg-0";
export var closeButton = "_gg-2";
export var greenCheckmark = "_gg-3";
export var hereLink = "_gg-4";
export var titleIcon = "_gg-1";